export default __webpack_public_path__ + "static/banner-mobile-two-f767140a04bf7cdd4a45165c4c645daf.jpg";